import React, { Component } from 'react';
import Constants from '../../../definitions/constants';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import toastr from 'toastr';

import Select from '../common/inputs/select';
import TextBox from '../common/inputs/textBox';
import { getMetricsList } from '../../actions/entityUseQuery';
import Button from '../common/inputs/button';

const initialObjectState = {
  id: "",
  label: "",
}

class ColumnsSelectList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState),
      toEditObjectPosition: null,   
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    };
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(!prevState.showOverlay && this.state.showOverlay) {
      InterfaceTooling.bringObjectEditorInputIntoView();
    }
  }
  
  isValidObject = (object) => {   
    if(!object.id || (!this.props.columnSelector && !object.label)){
      toastr.options = Constants.interface.tostrOptions;
      if(this.props.columnSelector){
        toastr.error(intl.formatMessage({ id: "virtualMetricAdmin.dimensions.emptyFieldsError"}));
      }
      else{
        toastr.error(intl.formatMessage({ id: "virtualMetricAdmin.value.emptyFieldsError"}));
      }
      return false;
    }
    return true;
  };
    
  handleAddButtonClick = (event) => {
    if(this.editItemInput) {
      this.editItemInput.focus();
    }
  };

  handleCancelAdd = (event) => {
    this.setState({
      showOverlay: false,
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    });
  };

  handleChangeAddItem = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    var toAddObject = JavascriptUtilsTooling.deepCopy(this.state.toAddObject);
    toAddObject[event.currentTarget.dataset.path] = value;
    if(event.currentTarget.dataset.path != "label" && !this.props.columnSelector){
      let metricFromValue = this.props.metricsList.find(item => item.id == value.split("_")[0]) ? this.props.metricsList.find(item => item.id == value.split("_")[0]) : {};
      if(metricFromValue.data_type == 'object'){
        toAddObject.label = metricFromValue.object_definition.find(prop => prop.id == value.split("_")[2]).name;
      }
      else{
        toAddObject.label = metricFromValue.name;
      }
    }
    this.setState({
      showOverlay: true,
      toAddObject: toAddObject
    });    
  };

  handleOnEnterAddItem = (event) => {
    if(this.addItemSaveButton) {
      this.addItemSaveButton.click();
    }
  };

  handleSaveAddItem = (event) => {
    if(this.isValidObject(this.state.toAddObject)) {
      event.currentTarget.columnSelector = true;
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
      });
    }
  };

  handleClickEdit = (event) => {
    let itemIndex = event.currentTarget.dataset.index;    
    let objectToEdit = JSON.parse(event.currentTarget.dataset.value);
    this.setState({    
      showOverlay: true,  
      toEditObjectPosition: itemIndex,
      toEditObject: objectToEdit
    });
  };

  handleChangeEdit = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    var toEditObject = JavascriptUtilsTooling.deepCopy(this.state.toEditObject);
    toEditObject[event.currentTarget.dataset.path] = value;
    if(event.currentTarget.dataset.path == "id" && !this.props.columnSelector){
      let metricFromValue = this.props.metricsList.find(item => item.id == value.split("_")[0]) ? this.props.metricsList.find(item => item.id == value.split("_")[0]) : {};
      if(metricFromValue.data_type == 'object'){
        toEditObject.label = metricFromValue.object_definition.find(prop => prop.id == value.split("_")[2]).name;
      }
      else{
        toEditObject.label = metricFromValue.name;
      }
    }
    this.setState({
      toEditObject: toEditObject
    });  
  };

  handleCancelEdit = (event) => {
    this.setState({
      showOverlay: false,
      toEditObjectPosition: null,
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    });
  };

  handleSaveEditItem = (event) => {
    if(this.isValidObject(this.state.toEditObject, this.state.toEditObjectPosition)) {
      event.currentTarget.columnSelector = true;
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toEditObjectPosition: null,
        toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
      });   
    }     
  };

  handleOnEnterEditItem = (event) => {
    if(this.editItemSaveButton) {
      this.editItemSaveButton.click();      
    }   
  };

  handleDeleteItem = (event) => {
    event.currentTarget.columnSelector = true; 
    this.props.onChange(event);
  }

  render() {
    const {
      className,
      values,
      onChange,
      columnOptions,
      dimensionsList,
      metricsList,
      columnSelector,
      getSelectKeysFromArrayWithMetricHandler,
      handleAutoGenerate,
      disabled
    } = this.props;
    const dataPath = this.props["data-path"];    
    let activeColumns = [];
    values.forEach((item, i) => {
      if(i!=this.state.toEditObjectPosition){
        activeColumns.push(item.id)
      }
    }) 

    // Filter available options for column selector, depending if its the dimensions or values component
    let filteredColumnOptions = [];
    if(columnSelector){
      // For dimensions selector, both present dimensions and already selected metric.dimension pairs must be filtered
      // 1. Filter already selected columns
      filteredColumnOptions = columnOptions ? columnOptions.filter(item => !activeColumns.includes(item.metric_id ? item.metric_id+"_"+item.id : item.id.toString()) || (this.state.toEditObject.id == (item.metric_id ? item.metric_id+"_"+item.id : item.id))) : [];
      
      // 2. Filter already selected dimensions (one dimension instance allowed for every dimension, no matter the metric of origin
      // - Get all active dimensions, except the one being edited (to allow changing the metric of origin (M1.D1 -> M2.D1))
      let activeDimensions = []
      values.forEach((item, i) => {
        if(i!=this.state.toEditObjectPosition){
          activeDimensions.push(+item.id.split("_")[1]);
        }
      });

      // - Filter already present dimensions
      filteredColumnOptions = filteredColumnOptions.filter(item => !(activeDimensions.includes(item.id)));
      filteredColumnOptions = getSelectKeysFromArrayWithMetricHandler(filteredColumnOptions, "id", "name", "metric_id");
    } 
    else{
      // Filter already selected values
      filteredColumnOptions = columnOptions ? columnOptions.filter(item => !activeColumns.includes(item.metric_id ? item.metric_id+"_v_"+item.id : item.id+"_v") || (this.state.toEditObject.id == (item.metric_id ? item.metric_id+"_v_"+item.id : item.id+"_v"))) : [];
      filteredColumnOptions = getSelectKeysFromArrayWithMetricHandler(filteredColumnOptions, "id", "name", "metric_id", true);
    }

    let blockAdd = filteredColumnOptions.length > 1 ? false : true;
    return (
      <div className={"custom-input free-text-list select-list object-editor object-template-headers-editor" + (className ? " " + className : "") + " select-list-no-search" + (className ? " " + className : "") + " select-list-no-search" + (this.state.showOverlay ? " free-text-list-overlay" : "")}>
        {this.state.showOverlay && (<div className="free-text-list-overlay-item"></div>)}
        <div className="free-text-list-label">
          {this.props["columnSelector"] ? <FormattedMessage id="virtualMetricAdmin.columnsSelector.header"/> : <FormattedMessage id="virtualMetricAdmin.valueSelector.header"/>}
          {(!disabled) &&
            <Button
              className="auto_generate_button"
              onClick={handleAutoGenerate}
              labelLocale={<FormattedMessage id="virtualMetricAdmin.columnsSelector.autoGenerateButtonLabel"/>}
              disabled={(activeColumns && activeColumns.length > 0) || blockAdd}
            />
          }
        </div>
          <div className="free-text-list-list-wrapper">
            {values && values.map((item,i) => {
              if(this.state.toEditObjectPosition == i) {
                return (
                  <div key={i} className="free-text-list-list-item free-text-list-list-item-edit virtual_metric_join_selector">
                    <div className="free-text-list-list-item-inner object-editor-inputs">
                      <div className="object-editor-inputs-linebreak"> 
                        <Select 
                          className="free-text-list-list-add-item"
                          value={this.state.toEditObject.id}
                          labelLocale={columnSelector ? <FormattedMessage id="virtualMetricAdmin.fields.dimensions.metric"/> : <FormattedMessage id="virtualMetricAdmin.fields.value.metric"/>}
                          options={filteredColumnOptions ? filteredColumnOptions : []}
                          onChange={this.handleChangeEdit}
                          data-path={"id"}
                        />
                        {(!columnSelector && values.length>1) &&
                          <TextBox
                            className="free-text-list-list-add-item"
                            styleType={Constants.interface.inputs.styleType.OUTLINED}
                            onChange={this.handleChangeEdit}
                            data-path={"label"}
                            value={this.state.toEditObject.label}
                            onKeyEsc={this.handleCancelEdit}
                            onKeyEnter={this.handleOnEnterEditItem}
                            type={Constants.interface.inputs.type.TEXT}
                            labelLocale={columnSelector ? <FormattedMessage id="virtualMetricAdmin.fields.dimensions.label"/> : <FormattedMessage id="virtualMetricAdmin.fields.value.label"/>}
                          />
                        }
                      </div>
                    </div>
                    {(!disabled && this.state.showOverlay) && (
                      <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-edit">
                        <i 
                          ref={(input) => { this.editItemSaveButton = input; }}
                          className="fas fa-save"
                          data-index={i}                        
                          data-value={JSON.stringify(this.state.toEditObject)}
                          data-objecteditor={"true"}
                          data-path={dataPath}
                          data-edit={"true"}
                          onClick={this.handleSaveEditItem}                      
                        />         
                        <i className="fas cancel-action fa-times-circle" onClick={this.handleCancelEdit}/>
                      </div>
                    )}
                  </div>
                );
              }
              else {
                let itemInnerText = metricsList.find(metric => metric.id==item.id.split("_")[0]).name
                itemInnerText += columnSelector ? ("."+dimensionsList.find(dim => dim.id==item.id.split("_")[1]).name) :
                 (item.id.split("_").length==3) ? ("."+columnOptions.find(col => col.id==item.id.split("_")[2]).name) :
                 ("."+intl.formatMessage({id: "virtualMetricAdmin.value.metricValueLabel"}));

                if(item.label && (values.length > 1) && !columnSelector) {
                  itemInnerText += ' ('+intl.formatMessage({id: "virtualMetricAdmin.value.LabelLabel"})+': "' + item.label + '")';
                }
                else if(!item.label && (values.length > 1) && !columnSelector) {
                  itemInnerText += " (" + intl.formatMessage({id: "virtualMetricAdmin.incompleteDataText"}) + ")"
                }
                return (
                  <div key={i} className={"free-text-list-list-item" + ((!item.label && !columnSelector) ? " free-text-list-list-item-required" : "")}>
                    <div title={itemInnerText} className="free-text-list-list-item-inner">
                      {itemInnerText}
                    </div>
                    {!disabled && (
                      <div className="free-text-list-list-item-action-buttons">
                        <i 
                          className="fas fa-edit"
                          onClick={this.handleClickEdit}
                          data-index={i}
                          data-value={JSON.stringify(item)}
                        />
                        <i
                          className="fas delete-action fa-trash"                          
                          data-index={i}
                          data-delete={"true"}
                          data-objecteditor={"true"}
                          data-value={JSON.stringify(item)}
                          data-path={dataPath}
                          onClick={this.handleDeleteItem}
                        />
                      </div>
                    )}
                  </div>
                );
              }
            })}
            <div className="free-text-list-list-item free-text-list-list-item-add virtual_metric_join_selector">
              <div className="free-text-list-list-item-inner">
                {(!disabled && !blockAdd && !this.state.toEditObjectPosition) && (
                  <div className="object-editor-inputs">
                    <div className="object-editor-inputs-linebreak">
                      <Select 
                        className="free-text-list-list-add-item"
                        value={this.state.toAddObject.id}
                        labelLocale={columnSelector ? <FormattedMessage id="virtualMetricAdmin.fields.dimensions.metric"/> : <FormattedMessage id="virtualMetricAdmin.fields.value.metric"/>}
                        options={filteredColumnOptions ? filteredColumnOptions : []}
                        onChange={this.handleChangeAddItem}
                        data-path={"id"}
                      />
                      {(!columnSelector && values.length>=1) &&
                        <TextBox
                          className="free-text-list-list-edit-item"
                          styleType={Constants.interface.inputs.styleType.OUTLINED}
                          onChange={this.handleChangeAddItem}
                          data-path={"label"}
                          value={this.state.toAddObject.label}
                          onKeyEsc={this.handleCancelAdd}
                          onKeyEnter={this.handleOnEnterAddItem}
                          type={Constants.interface.inputs.type.TEXT}
                          labelLocale={columnSelector ? <FormattedMessage id="virtualMetricAdmin.fields.dimensions.label"/> : <FormattedMessage id="virtualMetricAdmin.fields.value.label"/>}
                        />
                     }
                    </div>
                  </div>
                )}
              </div>
              {(!disabled && !blockAdd && this.state.showOverlay && !this.state.toEditObjectPosition) && (
                <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-add">
                  <i 
                    ref={(input) => { this.addItemSaveButton = input; }}
                    className="fas fa-save"
                    data-objecteditor={"true"}
                    data-value={JSON.stringify(this.state.toAddObject)}
                    data-path={dataPath}
                    onClick={this.handleSaveAddItem}   
                  />
                  <i 
                    className="fas cancel-action fa-times-circle"
                    onClick={this.handleCancelAdd}
                  />
                </div>
              )}
            </div>
          </div>
      </div>
    );
  }
}

export default ColumnsSelectList;



// WEBPACK FOOTER //
// ./source/client/components/virtualMetricAdmin/columnsSelecList.jsx